/*======================================
 Lamoraa Premium JS
======================================*/

document.addEventListener("DOMContentLoaded",()=>{

    /* Sticky Header */

    const header = document.querySelector("header");

    if(header){

        window.addEventListener("scroll",()=>{

            if(window.scrollY > 40){
                header.classList.add("lamoraa-scrolled");
            }else{
                header.classList.remove("lamoraa-scrolled");
            }

        });

    }


    /*=========================
      Reveal Animation
    =========================*/

    const observer = new IntersectionObserver((entries)=>{

        entries.forEach(entry=>{

            if(entry.isIntersecting){
                entry.target.classList.add("show");
            }

        });

    },{
        threshold:.15
    });


    /*======================================
      Lamoraa Auto Reveal
    ======================================*/

    function lamoraaReveal(){

        const selectors = [

            ".section-resource-list__header",
            ".resource-list__item",
            ".hero",
            ".banner",
            ".collection-list",
            ".card"

        ];

        selectors.forEach(selector=>{

            document.querySelectorAll(selector).forEach(el=>{

                if(!el.classList.contains("lam-reveal")){

                    el.classList.add("lam-reveal");

                    observer.observe(el);

                }

            });

        });

    }

    lamoraaReveal();

    document.addEventListener("shopify:section:load", lamoraaReveal);

});

